import * as React from "react"

import { ROOT_SCROLLABLE_ELEMENT } from "../../utils/constants"
import Footer from "./footer"
import FooterCardCta from "./footer/footer-card-cta"
import Header from "./header"
import * as styles from "./index.module.scss"
import useSetCampaignId from "./use-set-campaign-id"

interface Props {
  children?: React.ReactNode
  hideFooterCardCta?: boolean
  footerCardContent?: React.ReactNode
}

const Layout = ({ children, hideFooterCardCta, footerCardContent }: Props) => {
  useSetCampaignId()

  return (
    <main className={styles.container}>
      <Header />
      <div
        className={styles.scrollableContent}
        id={ROOT_SCROLLABLE_ELEMENT}
        data-testid="scrollable-content"
      >
        {children}
        <Footer
          footerCardContent={
            hideFooterCardCta ? null : (footerCardContent ?? <FooterCardCta />)
          }
        />
      </div>
    </main>
  )
}

export default Layout
